import { IconCamera } from '@vs-shop/ui/icons';
import { ProductGalleryThumbChip } from '@vs-shop/commerce-ui/productGallery';

import { getMemoizedIntlShapeWithDefaultLocale } from '../../../../../utils/intl';

type Props = { count: number; onClick: () => void };

/** The cell standing for the photographs the rail had no room for. */
export function GalleryThumbExtra({ count, onClick }: Props) {
  const intl = getMemoizedIntlShapeWithDefaultLocale();

  const formatedCount = intl.formatNumber(count, {
    style: 'decimal',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

  return (
    <ProductGalleryThumbChip
      onClick={onClick}
      tabIndex={0}
      aria-label={intl.formatMessage(
        {
          id: 'component.server.page.product.gallery.galleryThumbExtra.nextLabel',
          defaultMessage: '{count} {count, plural, one {další} few {další} other {dalších}}',
        },
        { count: formatedCount }
      )}
    >
      <IconCamera />
      <span>
        {intl.formatMessage(
          {
            id: 'component.server.page.product.gallery.galleryThumbExtra.nextSpan',
            defaultMessage: '+ {count} {count, plural, one {další} few {další} other {dalších}}',
          },
          { count: formatedCount }
        )}
      </span>
    </ProductGalleryThumbChip>
  );
}
